var render = function render(){var _vm=this,_c=_vm._self._c;return _c('branch-atm-widget-wc',{attrs:{"load-fonts":_vm.loadFonts,"search-page-url":_vm.searchPageUrl,"search-type":_vm.searchType}})
}
var staticRenderFns = []

export { render, staticRenderFns }